import EditZonesNamesModal from './containers/EditZonesNamesModalContainer'

export default EditZonesNamesModal
